import React from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import PublicMatchCard from "./PublicMatchCard";
import { ordenarFechas, numerosDeFecha, etiquetaFecha } from "components/torneos/fechas";
import { esWODoble, marcadorDePartido } from "components/torneos/resultado";

// Modal SOLO LECTURA con todos los partidos de un equipo en la zona, hasta la
// fecha que se está viendo (incluidos los que todavía no se jugaron). Es un
// listado corrido, de la fecha más reciente a la más vieja: no se agrupa ni se
// separa por fecha, cada partido lleva su rótulo arriba.
export default function PublicTeamModal({ zone, teams, teamId, upToFechaId, onClose }) {
  const teamName = (id) => {
    const t = teams.find((x) => x.id === id);
    return t ? t.name : "—";
  };

  // Cómo le fue al equipo en ese partido: "gano" | "empato" | "perdio".
  // null si todavía no se jugó o falta alguno de los dos equipos. Si los dos
  // dieron walk-over el partido se pierde, no se empata a 0.
  const resultadoDelEquipo = (m) => {
    if (!m.jugado || !m.homeTeamId || !m.awayTeamId) return null;
    if (esWODoble(m)) return "perdio";
    const marcador = marcadorDePartido(m);
    const propios = m.homeTeamId === teamId ? marcador.local : marcador.visitante;
    const ajenos = m.homeTeamId === teamId ? marcador.visitante : marcador.local;
    if (propios > ajenos) return "gano";
    if (propios < ajenos) return "perdio";
    return "empato";
  };

  const partidosDelEquipo = () => {
    if (!teamId) return [];
    const numeros = numerosDeFecha(zone.matchDates);
    const ordenadas = ordenarFechas(zone.matchDates);
    const indice = ordenadas.findIndex((f) => f.id === upToFechaId);
    const hasta = indice >= 0 ? ordenadas.slice(0, indice + 1) : ordenadas;

    const filas = [];
    hasta.forEach((f) => {
      (f.matches || [])
        .filter((m) => m.homeTeamId === teamId || m.awayTeamId === teamId)
        .sort((a, b) => {
          if (!a.hora) return 1;
          if (!b.hora) return -1;
          return a.hora.localeCompare(b.hora);
        })
        .forEach((m) => filas.push({ match: m, rotulo: etiquetaFecha(f, numeros[f.id], "corto") }));
    });
    return filas.reverse();
  };

  const filas = partidosDelEquipo();

  return (
    <Modal isOpen={!!teamId} toggle={onClose} centered scrollable className="tpub-equipo-modal">
      <ModalHeader toggle={onClose}>{teamName(teamId)}</ModalHeader>
      <ModalBody>
        {filas.length === 0 ? (
          <p className="tpub-empty tpub-empty--card">El equipo no tiene partidos.</p>
        ) : (
          filas.map(({ match, rotulo }) => (
            <div className="tpub-equipo-partido" key={match.id}>
              <div className="tpub-equipo-partido-fecha">{rotulo}</div>
              <PublicMatchCard match={match} teams={teams} resultado={resultadoDelEquipo(match)} />
            </div>
          ))
        )}
      </ModalBody>
    </Modal>
  );
}
